import Cashback from './views/cashback';
export default Cashback;
